<template>
    <TheSkinSwiper :showSkinArticles="drySkin" skinType="乾性肌" />
</template>

<script setup>
import { ref } from 'vue';
import TheSkinSwiper from '@/components/widget/TheSkinSwiper.vue';
import data from '@/assets/data/drySkin.json';

let drySkin = ref(data.articles);
</script>
